import { render, staticRenderFns } from "./FormalSectorChartByLGA.vue?vue&type=template&id=0bf56f72&"
import script from "./FormalSectorChartByLGA.vue?vue&type=script&lang=js&"
export * from "./FormalSectorChartByLGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports